import useSWR from 'swr'
import { auditsApi, type AuditsApiError } from '../api/index.ts'
import type { CardPage } from '../types.ts'
import { auditKeys } from './audits.keys.ts'

/** One card, read on demand; `refresh` re-mints the signed audio link when it expired. */
export function useCard(auditId: string | undefined, cardId: string | undefined) {
  const { data, error, isLoading, mutate } = useSWR<CardPage, AuditsApiError>(
    auditId && cardId ? auditKeys.card(auditId, cardId) : null,
    async () => {
      const result = await auditsApi.card(auditId!, cardId!)
      if (!result.success) throw result.error
      return result.data
    },
    { revalidateOnFocus: false },
  )
  return { page: data ?? null, error: error ?? null, isLoading, refresh: mutate }
}
